import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ButtonEmailRenderer } from "./email";
import { ButtonBlockProps } from "./types";

export function ButtonEditorRenderer(props: ButtonBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <div className="[&_a]:pointer-events-none [&_a]:cursor-default">
        <ButtonEmailRenderer isEditor {...props} />
      </div>
    </EmailComponentWrapper>
  );
}
